//magic strings

export const USER_SUBDOMAIN_DATA_SHARE_COOKIE_NAME = 'STREAMBANK_USER_DATA_COOKIE';

//keyboard values
export const SB_ENTER_KEY_CODE = 13;
export const SB_ESC_KEY_CODE = 27;

//env values
export const ARCGIS_TOKEN = '';
export const ENVIRONMENT = 'stage';
export const DOMAIN = 'stage.streambank.com';
export const REQUEST_NEW_SPECIES_FORM_URL = 'https://app.smartsheet.com/b/form/87a0ff40f547455c90fad812d0dc0bc2'